import Accordion from "../../../../../components/Accordion";
import FormInput from "../../../../../components/Form/FormInput";
import { Equipamiento } from "../../../../../types/Equipamiento";
import { FormEquipamientoErrors } from "../../validaciones";

type SeccionEquipamientoProps = {
    equipamientoForm: Equipamiento;
    setEquipamientoForm: (value: Equipamiento) => void;
    errors: FormEquipamientoErrors;
    edit: boolean;
    view: boolean;
}

const SeccionEquipamiento = ({ equipamientoForm, setEquipamientoForm, errors, edit, view }: SeccionEquipamientoProps) => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setEquipamientoForm({ ...equipamientoForm, [name]: value });
    }

    const onChangeEstado = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setEquipamientoForm({ ...equipamientoForm, activo: e.target.value === 'true' });
    }

    return (
        <Accordion id={'Equipamiento'} title="Equipamiento">
            <div className="row mt-3">
                <FormInput
                    id={'nombre'}
                    label={'Nombre'}
                    name={'nombre'}
                    value={equipamientoForm.nombre || ''}
                    isDisabled={edit || view}
                    onChange={onChange}
                    errorText={errors.nombre}
                    maxLength={255}
                />
            </div>
            <div className="row mt-3">
                <FormInput
                    id={'descripcion'}
                    label={'Descripción'}
                    name={'descripcion'}
                    value={equipamientoForm.descripcion || ''}
                    isDisabled={view}
                    onChange={onChange}
                    maxLength={255}
                />
            </div>
            <div className="row mt-3">
                <label htmlFor="activo" className="col-form-label col-2 text-end" style={{ color: 'grey' }}>Estado</label>
                <div className="col-4">
                    <select
                        id="activo"
                        name="activo"
                        className="form-control select-list"
                        value={String(equipamientoForm.activo !== false)}
                        onChange={onChangeEstado}
                        disabled={view}
                    >
                        <option value="true">ACTIVO</option>
                        <option value="false">INACTIVO</option>
                    </select>
                </div>
            </div>
            <div className="row mt-3"></div>
        </Accordion>
    )
}

export default SeccionEquipamiento;
